import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {
  Card,
  ClickableCard,
} from '@spaced-out/ui-design-system/lib/components/Card';
import {Table} from '@spaced-out/ui-design-system/lib/components/Table';

import {useHistory} from 'src/rerouter/index';
import {useToggle} from 'src/hooks/useToggle';
import {Shimmer} from '@spaced-out/ui-design-system/lib/components/Shimmer';

import {
  Panel,
  PanelBody,
  PanelHeader,
} from '@spaced-out/ui-design-system/lib/components/Panel';
import {TabList, Tab} from '@spaced-out/ui-design-system/lib/components/Tabs';
import {
  ButtonTextSmall,
  SubTitleLarge,
  SubTitleMedium,
  BodySmall,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {Chip} from '@spaced-out/ui-design-system/lib/components/Chip';
import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';
import moment from 'moment';
import {useSelector, useDispatch} from 'react-redux';
import CandidateDetailsCard from 'src/components/crm/jobs/job-info/overview/feedbacks/panels/candidate-details-card/candidate-details';
import ResumeCard from 'src/components/crm/jobs/job-info/overview/feedbacks/panels/resume/resume';
import {
  getJobInformation,
  getCandidateFeedbacks,
  getInterviewSchedules,
  getApplicantInformation,
  getInterviewFlow,
  getJobScoreCards,
} from 'src/action-creators/crm';
import {JobDescription} from 'src/components/crm/lib/job-description/job-description';
import {
  selectCandidateInterviewSchedules,
  selectJobInformation,
  selectCandidateFeedbacks,
} from 'src/selectors/crm';
import {useInflight} from 'src/hooks/redux';
import {JobDetailsTab} from 'src/components/crm/lib/job-details-tab/job-details-tab';
import GetCompletedInterviewData from 'src/components/crm/lib/candidate-evaluation/get-completed-interview-data';
import OnBehalfEvaluation from 'src/components/crm/lib/candidate-evaluation/on-behalf-evaluation';
import css from 'src/components/crm/jobs/job-info/overview/feedbacks/submit-feedbacks.css';
import * as reduxApi from 'src/utils/redux-api-v2';

import classify from 'src/utils/classify';
import {getSubmitFeedbackTabs} from 'src/components/crm/constant';
import ApplicantFeedbacks from 'src/components/crm/applicants/body/tabComponents/feedback-and-scorecards/feedback';
import {useApiQuery} from 'src/hooks/useApiQuery';


interface CompletedInterviewData {
  step: {
    showAllReviews: boolean;
  };
  candidate: {
    name: string;
  };
  job: {
    title: string;
    code: string;
    jobId: string;
  };
}

interface InterviewCard {
  id: number;
  candidateId: number;
  jobId: number;
  stepCandidateId: number;
  jobTitle: string;
  stepName: string;
  candidateName: string;
  subject: string;
  interviewDateAsString: string;
  conferenceLink: string;
  resumeKey: string;
  startDate: number;
  endDate: number;
}

type submitFeedbacksProps = {
  candidateStepId: string;
  candidateId: number;
  jobId: string;
  isOpen: boolean;
  handleClose?: () => void;
  intialTabId?: string;
  tabId?: string;
  type?: string;
  from?: string;
};

const SubmitFeedbacks = ({
  isOpen,
  handleClose,
  candidateStepId,
  candidateId: initialCandidateId,
  jobId: initialJobId,
  tabId,
  type,
  from,
}: submitFeedbacksProps) => {
  const history = useHistory();
  const {t} = useLabelTranslation();
  const SUBMIT_FEEDBACK_TABS = getSubmitFeedbackTabs(t);
  const {feedbackTabId} = history.location.query;
  const {
    stepCandidateId: urlStepCandidateId,
    candidateId: urlCandidateId,
    jobId: urlJobId,
  } = history.location.query;

  // Use URL params as source of truth, fallback to props
  const activeStepCandidateId = urlStepCandidateId || candidateStepId;
  const activeCandidateId = Number(urlCandidateId) || initialCandidateId;
  const activeJobId = urlJobId || initialJobId;

  const [feedbackPanelInfo, setFeedbackPanelInfo] = React.useState<{
    candidateName: string;
    jobTitle?: string;
    jobCode?: string;
    jobId?: string;
  } | null>(null);
  const [toggleValue, toggle] = useToggle(false);
  const isApplicantInformationLoading = useInflight(
    getApplicantInformation(activeCandidateId),
  );
  const intialTabId =
    SUBMIT_FEEDBACK_TABS.find((tab) => tab.tabId === feedbackTabId) ||
    SUBMIT_FEEDBACK_TABS[0];
  const [refetchApplicantData, setRefetchApplicantData] = React.useState(false);

  const [selected, setSelected] = React.useState(intialTabId);
  const jobInformation = useSelector(selectJobInformation);
  const InterviewData = useSelector(selectCandidateInterviewSchedules);
  const candidateFeedbacksData = useSelector(selectCandidateFeedbacks);
  const dispatch = useDispatch();
  const [selectedInterviewId, setSelectedInterviewId] = React.useState<
    string | number | null
  >(activeStepCandidateId || null);

  // Update selected interview when URL changes
  React.useEffect(() => {
    if (urlStepCandidateId) {
      setSelectedInterviewId(urlStepCandidateId);
    }
  }, [urlStepCandidateId]);

  const recentInterviewData = React.useMemo(() => {
    return (
      // @ts-expect-error - TS2339 - Property 'content' does not exist on type 'INTERVIEW_SCHEDULE[]'.
      InterviewData?.content?.filter((interview: any) => {
        const interviewDateTime = new Date(interview.endDate);
        const currentDateTime = new Date();
        return interviewDateTime <= currentDateTime;
      }) ?? []
    );
  }, [InterviewData]);

  const upcomingInterviewData = React.useMemo(() => {
    return (
      // @ts-expect-error - TS2339 - Property 'content' does not exist on type 'INTERVIEW_SCHEDULE[]'.
      InterviewData?.content?.filter((interview: any) => {
        const interviewDateTime = new Date(interview.endDate);
        const currentDateTime = new Date();
        return interviewDateTime > currentDateTime;
      }) ?? []
    );
  }, [InterviewData]);

  // Get the list of cards to display based on type
  const cardListData = React.useMemo(() => {
    // @ts-expect-error - TS2339 - Property 'content' does not exist on type 'INTERVIEW_SCHEDULE[]'.
    const interviewContent = InterviewData?.content ?? [];

    if (type === 'upcoming') {
      return upcomingInterviewData.length > 0 ? upcomingInterviewData : [];
    } else if (type === 'interview') {
      return recentInterviewData.length > 0 ? recentInterviewData : [];
    } else if (type === 'applicant') {
      return (candidateFeedbacksData as any)?.content ?? [];
    }

    return [];
  }, [
    type,
    InterviewData,
    recentInterviewData,
    upcomingInterviewData,
    candidateFeedbacksData,
  ]);

  const isSelectedInterviewPresent = React.useMemo(() => {
    if (!activeStepCandidateId) {
      return false;
    }

    return cardListData.some(
      (item: InterviewCard) =>
        String(item.stepCandidateId || item.id) ===
        String(activeStepCandidateId),
    );
  }, [cardListData, activeStepCandidateId]);

  const isInterviewOverdue = React.useCallback((endDate: string | Date) => {
    const today = moment().startOf('day');
    const interview = moment(endDate).startOf('day');
    return today.diff(interview, 'days') >= 1;
  }, []);

  React.useEffect(() => {
    if (activeJobId && Number(activeJobId) !== Number(jobInformation?.jobId)) {
      dispatch(getJobInformation(activeJobId));
    }
  }, [activeJobId]);

  React.useEffect(() => {
    toggle();
  }, []);

  const {data: completedInterviewData, isLoading: isHeaderLoading} =
    useApiQuery<CompletedInterviewData>(
      `/api/interview-candidates/${activeStepCandidateId}`,
      {
        queryOptions: {
          queryKey: ['completed-interview-data', activeStepCandidateId],
        },
        apiOptions: {
          method: 'GET',
          options: {
            apiPath: '/trmapi',
          },
        },
      },
    );
  React.useEffect(() => {
    if (completedInterviewData) {
      setFeedbackPanelInfo({
        candidateName: completedInterviewData?.candidate?.name,
        jobTitle: completedInterviewData.job?.title,
        jobCode: completedInterviewData.job?.code,
        jobId: completedInterviewData.job?.jobId,
      });
    }
  }, [completedInterviewData]);

  const isshowPastReviews = completedInterviewData?.step?.showAllReviews;

  const filteredTabs = React.useMemo(() => {
    if (!isshowPastReviews) {
      return SUBMIT_FEEDBACK_TABS.filter((tab) => tab.tabId !== 'PAST_REVIEWS');
    }
    return SUBMIT_FEEDBACK_TABS;
  }, [SUBMIT_FEEDBACK_TABS, isshowPastReviews]);

  const activeTab = React.useMemo(() => {
    const isSelectedTabAvailable = filteredTabs.some(
      (tab) => tab.tabId === selected.tabId,
    );
    if (!isSelectedTabAvailable) {
      return filteredTabs[0];
    }
    return selected;
  }, [filteredTabs, selected]);

  const fetchApplicantData = async () => {
    try {
      if (activeJobId && activeCandidateId) {
        await Promise.all([
          dispatch(getApplicantInformation(activeCandidateId, activeJobId)),
          dispatch(
            getInterviewFlow(
              activeJobId.toString(),
              activeCandidateId.toString(),
            ),
          ),
          dispatch(getJobScoreCards(Number(activeJobId))),
        ]);
      } else if (activeCandidateId) {
        await Promise.all([
          dispatch(getApplicantInformation(activeCandidateId)),
        ]);
      }
    } finally {
    }
  };

  React.useEffect(() => {
    fetchApplicantData();
  }, [refetchApplicantData, activeCandidateId, activeJobId]);

  const onSubmit = () => {
    if (from === 'DASHBOARD') {
      dispatch(getCandidateFeedbacks('PENDING'));
      dispatch(getInterviewSchedules('PENDING'));
      dispatch(getCandidateFeedbacks('COMPLETED'));
      dispatch(getInterviewSchedules('COMPLETED'));
    } else {
      dispatch(getCandidateFeedbacks('PENDING', activeJobId));
      dispatch(getInterviewSchedules('PENDING', activeJobId));
      dispatch(getCandidateFeedbacks('COMPLETED', activeJobId));
      dispatch(getInterviewSchedules('COMPLETED', activeJobId));
    }
  };

  const {
    candidateName,
    jobTitle,
    jobCode,
    jobId: feedbackJobId,
  } = feedbackPanelInfo || {};

  const renderTabContent = () => {
    switch (activeTab.tabId) {
      case 'FEEDBACK':
        return (
          <div className={css.feedbackContainer}>
            <GetCompletedInterviewData
              key={activeStepCandidateId}
              stepCandidateId={Number(activeStepCandidateId)}
              loaderComponent={
                <div className={css.loaderContainer}>
                  <CircularLoader />
                </div>
              }
            >
              {/* @ts-expect-error - TS2322 - Type '(completedInterviewData: any) => Element' is not assignable to type 'ReactNode'. | TS7006 - Parameter 'completedInterviewData' implicitly has an 'any' type. */}
              {(completedInterviewData) => (
                <OnBehalfEvaluation
                  stepCandidate={completedInterviewData}
                  sections={completedInterviewData.sectionSpecifics}
                  scorecard={completedInterviewData.scorecard}
                  step={completedInterviewData.step}
                  updateData={() => {
                    handleSelectNextCard();
                  }}
                  onCancel={() => {
                    handleClose?.();
                  }}
                />
              )}
            </GetCompletedInterviewData>
          </div>
        );
      case 'CANDIDATE_DETAILS':
        return (
          <CandidateDetailsCard
            candidateId={activeCandidateId}
            jobId={activeJobId}
          />
        );
      case 'RESUME':
        return (
          <ResumeCard applicantId={activeCandidateId} jobId={activeJobId} />
        );
      case 'BASIC_JOB_DETAILS':
        return (
          <JobDetailsTab
            jobDetails={jobInformation}
            hideCustomInfo={true}
            hideJobDescription={false}
          />
        );
      case 'PAST_REVIEWS':
        return (
          <ApplicantFeedbacks
            jobId={Number(activeJobId || feedbackJobId)}
            reloadCandidateData={() =>
              setRefetchApplicantData(!refetchApplicantData)
            }
            stepCandidateId={Number(activeStepCandidateId)}
            fromFeedbackPanel={true}
          />
        );

      default:
        return <div>{t('Select_a_tab', 'Select a tab')}</div>;
    }
  };

  const handleInterviewCardClick = (interview: any) => {
    const newStepCandidateId = interview.stepCandidateId || interview.id;
    setSelectedInterviewId(newStepCandidateId);
    const params = new URLSearchParams(window.location.search);
    params.set('stepCandidateId', newStepCandidateId);
    params.set('candidateId', interview.candidateId?.toString());
    if (from === 'DASHBOARD') {
      params.set('jobId', interview.jobId);
    }
    params.set('feedbackTabId', activeTab.tabId);
    params.set('type', type || 'interview');
    params.set('isReviewPanelOpen', 'true');
    params.set('candidateName', interview.candidateName);
    const rerouteUrl =
      from === 'DASHBOARD'
        ? '/dashboard'
        : `/crm/job/${activeJobId}/info/overview`;
    history.push(`${rerouteUrl}?${params.toString()}`);
  };

  // Handle selecting next card after feedback submission
  const handleSelectNextCard = React.useCallback(() => {
    onSubmit();

    const currentIndex = cardListData.findIndex(
      (item: any) =>
        String(item.stepCandidateId || item.id) ===
        String(activeStepCandidateId),
    );

    if (cardListData.length <= 1) {
      handleClose?.();
      return;
    }

    const nextIndex =
      currentIndex >= cardListData.length - 1 ? 0 : currentIndex + 1;
    const nextCard = cardListData[nextIndex];

    if (nextCard) {
      handleInterviewCardClick(nextCard);
    } else {
      handleClose?.();
    }
  }, [
    cardListData,
    activeStepCandidateId,
    onSubmit,
    handleClose,
    handleInterviewCardClick,
  ]);

  const FeedbackPanelHeader = () => {
    if (isHeaderLoading) {
      return <Shimmer classNames={{wrapper: css.shimmer}} />;
    }
    return (
      <>
        {candidateName ? `${t('for', 'for')} ${candidateName}` : ''}
        {jobTitle
          ? ` ( ${jobTitle} - ${jobCode ? jobCode : feedbackJobId} )`
          : ''}
      </>
    );
  };
  return (
    <Panel
      anchor="right"
      onClose={handleClose}
      size="large"
      tapOutsideToClose
      isOpen={isOpen}
      hideBackdrop={false}
      classNames={{
        content: classify({
          [css.panelContent]:
            cardListData.length > 0 && isSelectedInterviewPresent,
        }),
      }}
    >
      <div className={css.panelContetContainer}>
        {cardListData.length > 0 && isSelectedInterviewPresent && (
          <div className={css.panelContetLeft}>
            {cardListData?.map((interview: any) => (
              <ClickableCard
                key={interview.stepCandidateId || interview.id}
                onClick={() => handleInterviewCardClick(interview)}
                classNames={{
                  wrapper: classify(css.panelContetLeftClickableCard, {
                    [css.panelContetLeftClickableCardSelected]:
                      String(selectedInterviewId) ===
                      String(interview.stepCandidateId || interview.id),
                  }),
                }}
              >
                <div className={css.cardContainer}>
                  <div className={css.cardHeaderRow}>
                    <div className={css.cardTitleGroup}>
                      <SubTitleMedium>{interview.candidateName}</SubTitleMedium>
                      <BodySmall color="secondary">
                        {t('Candidate_Details', 'Candidate Details')}
                      </BodySmall>
                    </div>
                    {isInterviewOverdue(interview.endDate) ? (
                      <Chip semantic="danger">{t('Overdue', 'Overdue')}</Chip>
                    ) : (
                      <Chip semantic="primary">{t('Active', 'Active')}</Chip>
                    )}
                  </div>

                  <div className={css.cardDivider} />

                  <div className={css.metaList}>
                    {(interview.interviewDateAsString ||
                      interview.startDate) && (
                      <>
                        <div className={css.metaRow}>
                          <div className={css.iconBadge}>
                            <Icon name="calendar" size="small" />
                          </div>
                          <div className={css.metaText}>
                            <BodySmall color="secondary">
                              {t('Interview_Date', 'Interview Date')}
                            </BodySmall>
                            <BodySmall>
                              {interview.interviewDateAsString ||
                                moment(interview.startDate).format(
                                  'D MMMM YYYY ha',
                                )}
                            </BodySmall>
                          </div>
                        </div>
                        <div className={css.cardDivider} />
                      </>
                    )}

                    <div className={css.metaRow}>
                      <div className={css.iconBadge}>
                        <Icon name="briefcase" size="small" />
                      </div>
                      <div className={css.metaText}>
                        <BodySmall color="secondary">
                          {t('Job', 'Job')}
                        </BodySmall>
                        <BodySmall>
                          {interview.jobTitle}
                          {interview.jobId
                            ? ` (${t('Job_ID', 'Job ID')}: ${interview.jobId})`
                            : ''}
                        </BodySmall>
                      </div>
                    </div>
                    <div className={css.cardDivider} />
                    <div className={css.metaRow}>
                      <div className={css.iconBadge}>
                        <Icon name="compass" size="small" />
                      </div>
                      <div className={css.metaText}>
                        <BodySmall color="secondary">
                          {t('Round', 'Round')}
                        </BodySmall>
                        <BodySmall>{interview.stepName}</BodySmall>
                      </div>
                    </div>
                  </div>
                </div>
              </ClickableCard>
            ))}
          </div>
        )}
        <div className={css.panelContentDetail}>
          <PanelHeader onCloseButtonClick={handleClose} size="medium">
            <SubTitleLarge>
              {`${t('Feedback', 'Feedback')} `}
              {FeedbackPanelHeader()}
            </SubTitleLarge>
          </PanelHeader>
          {!isHeaderLoading && (
            <div className={css.tabSlot}>
              <TabList
                onSelect={(tab) => {
                  setSelected(tab);
                  const params = new URLSearchParams(window.location.search);
                  params.set('feedbackTabId', tab.tabId);
                  history.push(
                    `${window.location.pathname}?${params.toString()}`,
                  );
                }}
                selectedTab={{
                  label: activeTab.label,
                  tabId: activeTab.tabId,
                }}
                size="medium"
                classNames={{
                  wrapper: classify({
                    [css.tablist]: activeTab.tabId === 'FEEDBACK',
                  }),
                }}
              >
                {filteredTabs.map(({label, tabId, maxWidth}) => (
                  <Tab
                    key={tabId}
                    label={label}
                    tabId={tabId}
                    maxWidth={maxWidth}
                  />
                ))}
              </TabList>
            </div>
          )}
          <PanelBody
            className={classify(css.panelBody, {
              [css.padding]: activeTab.tabId === 'FEEDBACK',
            })}
          >
            {isApplicantInformationLoading ? (
              <CircularLoader />
            ) : (
              renderTabContent()
            )}
          </PanelBody>
        </div>
      </div>
    </Panel>
  );
};

export default SubmitFeedbacks;
